import React from 'react'

export default function UpArrow() {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 10.5L8 6.5L12 10.5" stroke="#39BDCD" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
